//import {mapGetters} from 'vuex'

const formatMontant = {
    install(Vue) {

        //Format Montant
        Vue.prototype.$FM1 =  function(sNombre, decimales, signe, separateurMilliers) {
            
            sNombre = String(sNombre)

            // eslint-disable-next-line no-unused-vars
            var _sNombre = String(this),
            i, _sRetour = "",
            _sDecimales = "";
            if (decimales == undefined) decimales = 2;
            if (signe == undefined) signe = '.';
            if (separateurMilliers == undefined) separateurMilliers = ' ';
        
            function separeMilliers(sNombre) {
                var sRetour = "";
                while (sNombre.length % 3 != 0) {
                    sNombre = "0" + sNombre;
                // console.log(sNombre)
                }
                for (i = 0; i < sNombre.length; i += 3) {
                    if (i == sNombre.length - 1) separateurMilliers = '';
                    sRetour += sNombre.substr(i, 3) + separateurMilliers;
                //  console.log(sRetour);
                }
                while (sRetour.substr(0, 1) == "0") {
                    sRetour = sRetour.substr(1);
                //  console.log(sRetour);
                }
                //  console.log(sRetour.substr(0, sRetour.lastIndexOf(separateurMilliers)))
                return sRetour.substr(0, sRetour.lastIndexOf(separateurMilliers));
            }
            // console.log(sNombre);
            if (sNombre.indexOf('.') == -1) {
                //_sDecimales="";
                for (i = 0; i < decimales; i++) {
                    //     console.log(_sDecimales);
                    _sDecimales += "0";
                }
                _sRetour = separeMilliers(sNombre) + signe + _sDecimales;
            // console.log(_sRetour);
            } else {
                var sDecimalesTmp = (sNombre.substr(sNombre.indexOf('.') + 1));
                if (sDecimalesTmp.length > decimales) {
                    var nDecimalesManquantes = sDecimalesTmp.length - decimales;
                    var nDiv = 1;
                    for (i = 0; i < nDecimalesManquantes; i++) {
                        nDiv *= 10;
                    }
                    _sDecimales = Math.round(Number(sDecimalesTmp) / nDiv);
                } else {
                    _sDecimales = sDecimalesTmp;
                    for (i = sDecimalesTmp.length; i < decimales; i++) {
                        _sDecimales += "0";
                    }
                }
                _sRetour = separeMilliers(sNombre.substr(0, sNombre.indexOf('.'))) + String(signe) + _sDecimales;
            }

            if (_sRetour.substr(0,1) == ".")
            {_sRetour = "0" + _sRetour}

            return _sRetour + " $";
        },
        Vue.prototype.$FM =  function(montant, decimal) {
            if(montant == null){montant = 0}
            return montant.toFixed(decimal) + ' $';
        },
        Vue.prototype.$TPS =  function(Montant, decimal) {
            if(Montant == null){Montant = 0}
            return ((Montant * 5) / 100).toFixed(decimal) + ' $';
        },
        Vue.prototype.$TVQ =  function(Montant, decimal) {
            if(Montant == null){Montant = 0}
            return ((Montant * 9.975) / 100).toFixed(decimal) + ' $';
        }
        Vue.prototype.$AddTaxe =  function(Montant, decimal) {
            if(Montant == null){Montant = 0}
            var tps = (Montant * 5) / 100
            var tvq = (Montant * 9.975) / 100
            var totalTx = tps + tvq
            return (Montant + totalTx).toFixed(decimal) + ' $';
        },
        Vue.prototype.$FDouble =  function(montant, decimal) {
            console.log('FDOUBLE : ' + montant + ' : ' + decimal)
            if(montant == null){montant = 0}
            console.log('FDOUBLE RESULT : ' + montant.toFixed(decimal))
            return montant.toFixed(decimal);
        },
        Vue.prototype.$FP =  function(montant, decimal) {
            if(montant == null){montant = 0}
            return montant.toFixed(decimal) + ' %';
        }
    }
}
    
export default formatMontant